import React from 'react';
import PropTypes from 'prop-types';
import maintenancePng from '../../../theme/img/maintenance.png';
import Button from '../common/Button';

export const Maintenance = (props) => {
  const {
    tr,
  } = props;

  const handleReload = () => document.location.reload(true);

  return (
    <div className="errorBoundary">
      <div className="errorBoundary__overlay" />
      <div className="errorBoundary__container">
        <div className="errorBoundary__body">
          <img
            className="errorBoundary__body-image"
            src={maintenancePng}
            alt="error-img"
          />
          <h1>{tr.dashboard.errorMaintenanceTitle}</h1>
          <div className="errorBoundary__body-description">
            <span>{tr.dashboard.errorMaintenanceDesc1}</span>
            <a
              className="link link__green"
              href="mailto:support@clevergig.nl"
              rel="noopener noreferrer"
            >
              {tr.common.contactUs}
            </a>
            <span>{tr.dashboard.errorMaintenanceDesc2}</span>
          </div>
          <div className="errorBoundary__body-action">
            <div>
              {tr.dashboard.errorAction}
            </div>
            <Button
              className="btn btn--shadow btn--small white --marginLeft-10"
              onClick={handleReload}
            >
              {tr.common.refresh}
            </Button>
          </div>

        </div>
      </div>
    </div>
  );
};

Maintenance.propTypes = {
  tr: PropTypes.object.isRequired,
};